<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form @submit.prevent="handleSubmit">
                <div class="login-form">
                <p class="h4">HOW DO YOU WANT TO LOG IN YOUR ACCOUNT?</p>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" v-model="loginType" value="Cert">
                    <label class="form-check-label" for="flexRadioDefault1">
                      By my Certificate Number.
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" v-model="loginType" value="Personal">
                    <label class="form-check-label" for="flexRadioDefault2">
                      By my Personal Information.
                    </label>
                </div>
               </div>
               <div class="col-md-12">
                <router-link to="/member-login"><a style="float:left" type="button" class="btn btn-primary btn-lg">CANCEL</a></router-link>
                <button class="btn btn-primary btn-lg no-link-btn" disabled>PREVIOUS</button>
                <button class="btn btn-primary btn-lg">NEXT</button>

            </div>
              </form>
             </div> 

             

        </section>
</body>
</template>

<script>
export default {
  name: 'PhilLogin',
  
  data() {
    return {
      loginType: 'Cert'
      
    }
  },
  methods: {
     handleSubmit() {
        if (this.loginType === "Cert") {
          this.$router.push('/input-number');
        } else {
          this.$router.push('/personal-info');
        }
        
    }
  }
  }




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
